"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITEM_SUBTYPES = exports.ITEM_TYPES = void 0;
const ITEM_TYPES = {
  CAMERA_EQUIPMENT: 'Camera Equipment',
  AUDIO_EQUIPMENT: 'Audio Equipment',
  DRONES: 'Drones',
  MOBILITY: 'Mobility',
  PARTY_EVENTS: 'Party & Events',
  ENTERTAINMENT: 'Entertainment',
  MUSICAL_INSTRUMENTS: 'Musical Instruments',
  OUTDOOR: 'Outdoor',
  MISC: 'Miscellaneous'
};
exports.ITEM_TYPES = ITEM_TYPES;
const ITEM_SUBTYPES = {
  CAMERAS: 'Cameras',
  LENSES: 'Lenses',
  LIGHTING: 'Lighting',
  AUDIO_EQUIPMENT: 'Audio Equipment',
  TRIPODS_RIGS: 'Tripods & Rigs',
  ACCESSORIES: 'Accessories',
  STUDIO_SPACES: 'Studio Spaces',
  SPEAKERS: 'Speakers',
  MICROPHONES: 'Microphones',
  DJ_EQUIPMENT: 'DJ Equipment',
  DRONES: 'Drones',
  BIKES: 'Bikes',
  ELECTRIC_SCOOTERS: 'Electric Scooters',
  ELECTRIC_SKATEBOARDS: 'Electric Skateboards',
  CATERING_EQUIPMENT: 'Catering Equipment',
  DECORATIONS: 'Decorations',
  FURNITURE: 'Furniture',
  CANOPY_TENT: 'Canopy Tent',
  CATERING_EQUIPMENT: 'Catering Equipment',
  VIDEO_GAMES: 'Video Games',
  TVS: 'TVs',
  PROJECTORS: 'Projectors',
  VR: 'VR',
  GUITARS: 'Guitars',
  AMPS: 'Amps',
  KEYBOARDS: 'Keyboards',
  STRING_INSTRUMENTS: 'String Instruments',
  BRASS: 'Brass',
  WOODWIND: 'Woodwind',
  PERCUSSION: 'Percussion',
  CAMP_HIKING: 'Camp & Hiking',
  FISHING_GEAR: 'Fishing Gear',
  CLIMBING_GEAR: 'Climbing Gear',
  SPORTS: 'Sports'
};
exports.ITEM_SUBTYPES = ITEM_SUBTYPES;
//# sourceMappingURL=itemTypes.js.map